






import { Vue, Component } from "vue-property-decorator";
import { User } from '@/components/User';
import Login from './pages/login.vue';
import Land from './pages/gisagro.land.vue';
import GISagroMap from './pages/gisagro.map.vue';
import DoaeMap from './pages/doae.map.vue';
import Rice from './pages/rice.vue';
import EcoPlant from './pages/ecoplant.vue';
import Home from './pages/home.vue';
import PrintLandMap from './pages/print.land.vue';
import PrintGISagroMap from './pages/print.map.vue';
import PrintEcoplantMap from './pages/print.ecoplant.vue';
import PrintDashboard from './pages/print.dashboard.vue';
import ComingSoon from './pages/comingsoon.vue';

@Component({
  components: {
    'login': Login,
    'home' : Home,
    'rice': Rice,
    'ecoplant' : EcoPlant,
    'land': Land,
    'gisagromap': GISagroMap, //cannot use 'map': Do not use built-in or reserved HTML elements as component id
    'doaemap': DoaeMap,
    'printland': PrintLandMap,
    'printmap': PrintGISagroMap,
    'printecoplant': PrintEcoplantMap,
    'printdashboard': PrintDashboard,
    'comingsoon': ComingSoon
  }
})
export default class App extends Vue {
  userToken:string = null;
  
  async created() {
    let app = 'home'; // default;
    let path = window.location.hash;
    if (path) {
      if (path.indexOf('?')>0) {
        //has always starts with '#' and exists at the end of url.
        //however, it may be wrongly placed before query parameters
        //so we need to detect and extract it correctly
        path = path.substring(0,path.indexOf('?'));
      }
      path = path.substr(1); // remove #
    } else {
      path = window.location.pathname.substr(1);
    }
    if (path && path.match(/^comingsoon/i)) {
      app = 'comingsoon';
    } else if (path && path.match(/^ecoplant/i)) {
      app = 'ecoplant';
    } else if (path && path.match(/^rice/i)) {
      app = 'rice';
    } else if (path && path.match(/^map|gisagromap/i)) {
      app = 'gisagromap';
    } else if (path && path.match(/^doaemap/i)) {
      app = 'doaemap';
    } else if (path && path.match(/^land|gisagroland/i)) {
      app = 'land';
      /*if (!this.user.hasLoggedIn) {
        // todo: how to share state when app is reloaded
        // 1. cookie 2. localStorage but how to determine 
        // if use has logged in or not ,maybe a valid token?
        this.userToken = this.getParameter('token');
        if (!this.userToken) {
          app = 'login';
        } else {
          //login in after mounted()
        }
      } else {
        app = 'land';
      }*/
    } else if (path && path.match(/^print/i) && !path.match(/print$/i)) {
      app = path.toLowerCase();
    } else {
      let host = window.location.hostname;
      if (host.match(/ecoplant\.gistda\.or\.th/i)) {
        app = 'ecoplant';
      } else if (host.match(/rice\.gistda\.or\.th/i)) {
        app = 'rice';
      }
    }
    window.name = app=='home' ? 'GISagro' : app;
    this.$store.commit('notifyChange', {
      Page: app
    });
  };

  get Page() {
    return this.$store.getters.Page || 'home';
  };
}
